import React, { useRef, useState,useContext,useEffect } from 'react';
import { 
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, 
  Typography, Button, Box, Grid, Container,Snackbar,Alert,Modal
} from '@mui/material';
import { useReactToPrint } from 'react-to-print';
import AppContext from '../AppContext';
import { getDoc, doc } from 'firebase/firestore';
import { db } from '../firebase'; // Adjust the import based on your Firebase setup
import { format, isValid } from "date-fns";

const OrderSummaryPrint = ({ orderDetails, onClose, shopInfo }) => {
  const componentRef = useRef();
  //eslint-disable-next-line
  const [isPrinting, setIsPrinting] = useState(false);
  const { shopId, t } = useContext(AppContext);  
  const [shopData, setShopData] = useState({
    shopLogo: '',
    shopName: '',
    shopAddress: '',
    phoneNumber: '',
  });
  //eslint-disable-next-line
  const [loading,setLoading]=useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const printStyles = `
    @media print {
      @page {
        size: 80mm auto;
        margin: 0 !important;
        padding: 0 !important;
      }
      body {
        width: 80mm;
        margin: 0 !important;
        padding: 0 !important;
        line-height: 1.2;
      }
      .print-container {
        width: 100%;
        font-size: 12px !important; /* Base font size for print */
        min-height: unset; /* Remove any minimum height constraints */
        height: auto; /* Let height be determined by content */
        break-inside: avoid; /* Prevent page breaks within the container */
        margin: 0 !important; /* Remove margin */
        padding: 0 !important; /* Remove padding */
      }
      h3 { font-size: 20px !important; margin: 4px 0; }
      h4 { font-size: 14px !important; margin: 4px 0; }
      img { max-width: 60px; height: auto; }
      .MuiTypography-root { font-size: 12px; }
      .MuiTableCell-root { font-size: 12px;padding: 2px 8px !important; }
      .MuiGrid-item { font-size: 12px;padding: 2px !important; }
    }
      /* Ensure no extra space after content */
    .print-container > *:last-child {
      margin-bottom: 0 !important;
      padding-bottom: 0 !important;
    }
    /* Prevent breaking of table and grid content */
    .MuiTable-root, .MuiGrid-container {
      break-inside: avoid;
    }
      `;

  const handlePrint = useReactToPrint({
    content: () => {
     try {
        if (componentRef.current) {
          return componentRef.current;
        }
        throw new Error('Print content not found');
      }catch (error) {
        setErrorMessage("Error fetching content for printing.");
        setOpenSnackbar(true);
        return null;
      }
    },
    onBeforeGetContent: () => {
      try {
        setIsPrinting(true);
      } catch (error) {
        setErrorMessage("Error before getting content.");
        setOpenSnackbar(true);
      }
    },
    onAfterPrint: () => {
      try {
        setIsPrinting(false);
      } catch (error) {
        setErrorMessage("Error after printing.");
        setOpenSnackbar(true);
      }
    }
  });
  

  useEffect(() => {
    if (shopId) {
      setLoading(true);
      try{
        fetchShopData(shopId);
      }
      catch(error)
      {
        console.log(error);
      }
      finally{
        setLoading(false);
      }
      
    }
  },[shopId]);

  const fetchShopData = async (id) => {
    const docRef = doc(db, 'shops', id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      setShopData(docSnap.data());
    } else {
      console.log('No such document!');
    }
  };

  const formatToMyanmarCurrency = (number) => {
    const formattedNumber = new Intl.NumberFormat('my-MM').format(number);
    return `${formattedNumber}`;
  };


  return (
    <Container className="print-container">
     {/* <style>{printStyles}</style> */}
    <Box ref={componentRef}>
      <Box textAlign="center" mb={0}>
      {shopData.shopLogo && (
          <img 
            src={shopData.shopLogo} 
            alt="Shop Logo" 
            sx={{ maxWidth: '100px', marginBottom: '10px', marginTop: '10px' }} 
          />
        )}
        <Typography variant="h3">{shopData.shopName}</Typography>
        <Typography>{shopData.shopAddress}</Typography>
        <Typography>{shopData.phoneNumber}</Typography>
      </Box>
      <Typography sx={{ borderBottom: '1px dashed', width: '100%', my: 1 }}></Typography>
      <Typography variant="h4" textAlign="center">
        #{orderDetails.orderID}
      </Typography>
      <Typography textAlign="center">
      {orderDetails.orderDate && (
            orderDetails.orderDate instanceof Date 
            ? format(orderDetails.orderDate, "dd-MM-yyyy h:mm a")
            : orderDetails.orderDate.toDate 
            ? format(orderDetails.orderDate.toDate(), "dd-MM-yyyy h:mm a")
            : "Invalid date"
            )}
      </Typography>
     
      <Grid container spacing={1} m={0}>
        <Grid item xs={4}>
          <Typography>ရက်ချိန်း</Typography>
        </Grid>
        <Grid item xs={8}>
        <Typography>
           {orderDetails.fulfillmentDate && (
            orderDetails.fulfillmentDate instanceof Date 
            ? format(orderDetails.fulfillmentDate, "dd-MM-yyyy h:mm a")
            : orderDetails.fulfillmentDate.toDate 
            ? format(orderDetails.fulfillmentDate.toDate(), "dd-MM-yyyy h:mm a")
            : "Invalid date"
            )}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography>မှာသူအမည်</Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography>{orderDetails.customerName}</Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography>ဖုန်းနံပါတ်</Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography>{orderDetails.phoneNumber}</Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography>စက်ကိုင်ဝန်ထမ်း</Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography>{orderDetails.cashierName}</Typography>
        </Grid>
        {orderDetails.fulfillmentMethod === 'Delivery' && (
          <>
            <Grid item xs={4}>
              <Typography>ပို့ရန်လိပ်စာ</Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography>{orderDetails.deliveryAddress}</Typography>
            </Grid>
          </>
        )}
      </Grid>

      <TableContainer sx={{mt:1,mb:0}}>
        <Table>
          <TableBody>
            {orderDetails.cartItems.map((item, index) => (
               <React.Fragment key={index}>
              <TableRow>
                <TableCell sx={{ border: 'none', padding: '0px 10px' }}>{item.name}-{item.selectedVariant}</TableCell>
                <TableCell sx={{ border: 'none', padding: '0px 16px' }} align="right">{formatToMyanmarCurrency(item.totalPrice)}</TableCell>
                </TableRow>
                <TableRow>
                <TableCell sx={{ border: 'none', padding: '0px 10px' }}>{item.quantity} x {formatToMyanmarCurrency(item.price + item.variantPrice)}</TableCell>
                <TableCell sx={{ border: 'none', padding: '0px 16px' }}></TableCell>
                </TableRow>
                <TableRow>
                <TableCell sx={{ border: 'none', padding: '0px 10px' }}>{item.inscription}</TableCell>
                <TableCell sx={{ border: 'none', padding: '0px 16px' }}></TableCell>
                </TableRow>
                 </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Grid container sx={{paddingRight:'10px',spacing:1}} mt={0}>
        <Grid item xs={9} align="right">
          <Typography>သင့်ငွေ</Typography>
        </Grid>
        <Grid item xs={3} align="right">
          <Typography sx={{paddingRight:'0px'}}>{formatToMyanmarCurrency(orderDetails.subtotal)}</Typography>
        </Grid>
        {/* 
        <Grid item xs={9} align="right">
          <Typography>စားသုံးခွန်</Typography>
        </Grid>
        <Grid item xs={3} align="right">
          <Typography sx={{marginRight:'16px'}}>{formatToMyanmarCurrency(orderDetails.tax)}</Typography>
        </Grid>
        */}
        {orderDetails.fulfillmentMethod === 'Delivery' && orderDetails.deliveryFeeType === 'Advance' && (
          <>
            <Grid item xs={9} align="right">
              <Typography>ပို့ခ</Typography>
            </Grid>
            <Grid item xs={3} align="right">
              <Typography sx={{paddingRight:'0px'}}>{formatToMyanmarCurrency(orderDetails.deliveryFeeAmount)}</Typography>
            </Grid>
          </>
        )}
        {/*
        <Grid item xs={9} align="right">
          <Typography>‌လျှော့ငွေ</Typography>
        </Grid>
        <Grid item xs={3} align="right">
          <Typography  sx={{marginRight:'16px'}}>{formatToMyanmarCurrency(orderDetails.discount)}</Typography>
        </Grid>
         */}
        <Grid item xs={9} align="right">
          <Typography>စုစုပေါင်း</Typography>
        </Grid>
        <Grid item xs={3} align="right">
          <Typography  sx={{paddingRight:'0px'}}>{formatToMyanmarCurrency(orderDetails.total)}</Typography>
        </Grid>
        {orderDetails.payments && orderDetails.payments.map((payment, index) => (
            <React.Fragment key={index}>
              <Grid item xs={9} align="right">
                <Typography>{`ပေးငွေ (${payment.method})`}</Typography>
              </Grid>
              <Grid item xs={3} align="right">
                <Typography sx={{paddingRight:'0px'}}>{formatToMyanmarCurrency(payment.amount)}</Typography>
              </Grid>
            </React.Fragment>
          ))}
          <Grid item xs={9} align="right">
            <Typography>စုစုပေါင်းပေးငွေ</Typography>
          </Grid>
          <Grid item xs={3} align="right">
            <Typography sx={{paddingRight:'0px'}}>{formatToMyanmarCurrency(orderDetails.payments?.reduce((sum, p) => sum + p.amount, 0) || 0)}</Typography>
          </Grid>
          <Grid item xs={9} align="right">
            <Typography sx={{ fontWeight: 'bold' }}>ကျန်ငွေ</Typography>
          </Grid>
          <Grid item xs={3} align="right">
            <Typography sx={{paddingRight:'0px',fontWeight:'bold'}}>{formatToMyanmarCurrency(orderDetails.remainingBalance)}</Typography>
          </Grid>
        </Grid>
      {/* 
      <Typography gutterBottom mt={3} ml={2}>{t("Remark")}</Typography>
      <Typography ml={2}>{orderDetails.customerNotes}</Typography>   
      */}     
    </Box>
    <Box mt={3} display="flex" justifyContent="space-between">
    <Button variant="contained" color="primary" onClick={handlePrint}>
      Print Receipt
    </Button>
    <Button variant="outlined" onClick={onClose}>
      Close
    </Button>
  </Box>
  
  </Container>
  );
};

export default OrderSummaryPrint;
